"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var AlertContext_1 = require("./AlertContext");
var style = __importStar(require("./Alert.style"));
var Alert = function (props) {
    var children = props.children, _a = props.color, color = _a === void 0 ? 'blue' : _a, _b = props.className, className = _b === void 0 ? 'alert' : _b, _c = props.fullWidth, fullWidth = _c === void 0 ? false : _c, _d = props.size, size = _d === void 0 ? 'small' : _d, _e = props.variant, variant = _e === void 0 ? 'light' : _e, _f = props.hidden, hidden = _f === void 0 ? false : _f, _g = props.status, status = _g === void 0 ? 'info' : _g, _h = props.boxShadow, boxShadow = _h === void 0 ? false : _h;
    var propStyles = [
        style.fullWidth(fullWidth),
        size && style.size(size),
        boxShadow && style.boxShadow,
        color && variant && style.variantStyle(color, variant),
        hidden ? style.hiddenStyle : style.visibleStyle,
    ];
    return ((0, jsx_runtime_1.jsx)(AlertContext_1.Provider, __assign({ variant: variant, color: color, size: size, status: status }, { children: (0, jsx_runtime_1.jsx)("div", __assign({ css: __spreadArray([style.base], __read(propStyles), false), className: className }, { children: children })) })));
};
exports.default = Alert;
//# sourceMappingURL=Alert.js.map